import React from "react";
import {
  Container,
  Box,
  Typography,
  Alert,
  Button,
} from "@mui/material";
import { styled } from "@mui/system";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BlockIcon from "@mui/icons-material/Block";
import SearchOffIcon from "@mui/icons-material/SearchOff";

const StyledButton = styled(Button)({
  fontWeight: "bold",
  backgroundColor: "#000",
  color: "#fff",
  marginTop: "20px",
  "&:hover": {
    backgroundColor: "#ff0000",
  },
});

const LinkStatusScreen = ({ status, message, onRetry }) => {
  const getStatusConfig = () => {
    switch (status) {
      case "not_found":
        return {
          icon: <SearchOffIcon sx={{ fontSize: 80, color: "#666" }} />,
          title: "Link Not Found",
          description: "The link you are trying to access does not exist or has been deleted.",
          color: "warning",
        };
      case "expired":
        return {
          icon: <AccessTimeIcon sx={{ fontSize: 80, color: "#f57c00" }} />,
          title: "Link Expired",
          description: "This link has expired. Secure payment links have a validity of 24 hours.",
          color: "warning",
        };
      case "already_used":
        return {
          icon: <BlockIcon sx={{ fontSize: 80, color: "#d32f2f" }} />,
          title: "Link Already Used",
          description: "This link has already been used to process a payment. It cannot be used again.",
          color: "error",
        };
      case "error":
        return {
          icon: <ErrorOutlineIcon sx={{ fontSize: 80, color: "#d32f2f" }} />,
          title: "Validation Error",
          description: "An error occurred while validating the link. Please contact the administrator.",
          color: "error",
        };
      default:
        return {
          icon: <ErrorOutlineIcon sx={{ fontSize: 80, color: "#666" }} />,
          title: "Unknown Status",
          description: "The status of the link could not be determined.",
          color: "info",
        };
    }
  };

  const config = getStatusConfig();

  return (
    <Container component="main" maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
        textAlign="center"
      >
        {config.icon}
        
        <Typography
          variant="h4"
          component="h1"
          style={{
            fontFamily: "Lato, sans-serif",
            marginTop: "20px",
            marginBottom: "10px",
            fontWeight: "bold",
          }}
        >
          {config.title}
        </Typography>
        
        <Typography
          variant="body1"
          color="textSecondary"
          style={{
            marginBottom: "30px",
            maxWidth: "400px",
            lineHeight: "1.6",
          }}
        >
          {config.description}
        </Typography>

        {message && (
          <Alert 
            severity={config.color} 
            style={{ marginBottom: "20px", width: "100%" }}
          >
            {message}
          </Alert>
        )}

        {onRetry && (
          <StyledButton
            variant="contained"
            onClick={onRetry}
          >
            Intentar Nuevamente
          </StyledButton>
        )}

        <Typography
          variant="body2"
          color="textSecondary"
          style={{
            marginTop: "40px",
            padding: "20px",
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            maxWidth: "400px",
          }}
        >
          <strong>Need help?</strong><br />
          If you believe this is an error, contact the system administrator 
          or request a new secure payment link.
        </Typography>
      </Box>
    </Container>
  );
};

export default LinkStatusScreen; 